import { Outlet } from 'react-router';
import { AccessDenied } from '../../_pages/AccessDenied';
import { useConfigValuesState } from '../../hooks/useConfigValue';

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
    const {
        initialData: {
            aggregatedUser: { originalUser, user },
        },
    } = useConfigValuesState();

    const hasAccess: boolean =
        // User is not impersonating another user AND is admin or has user/delegate permissions
        originalUser.id === user.id && (originalUser.isAdmin || originalUser.permissions?.user || originalUser.permissions?.delegates);

    if (!hasAccess) {
        return <AccessDenied />;
    }

    return children ? <>{children}</> : <Outlet />;
};
